var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nocontent"},[_c('img',{attrs:{"src":require("@/assets/home/nocontent.png"),"alt":""}}),(_vm.tag == 'login')?[_c('p',[_vm._v("您还没登录，快去登录吧")]),_c('el-button',{attrs:{"type":"primary","round":""},on:{"click":_vm.handleToLogin}},[_vm._v("去登录")])]:[_c('p',[_vm._v("暂无内容")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }